import { getTheme } from "../../../graphic/theme";

import { rectFillVisible, rectStrokeVisible, runFill, runStroke } from "./utils";

import { RECT3D_NUMBER_TYPE } from "../../../graphic/constants";

import { Base3dRender } from "./base-3d-render";

export class DefaultCanvasRect3dRender extends Base3dRender {
    constructor() {
        super(...arguments), this.type = "rect3d", this.numberType = RECT3D_NUMBER_TYPE;
    }
    drawShape(rect, context, x, y, drawContext, params, fillCb, strokeCb) {
        var _a, _b;
        const rectAttribute = getTheme(rect, null == params ? void 0 : params.theme).rect, {fill: fill = rectAttribute.fill, stroke: stroke = rectAttribute.stroke, x1: x1, y1: y1, x: originX, y: originY, opacity: opacity = rectAttribute.opacity, fillOpacity: fillOpacity = rectAttribute.fillOpacity, lineWidth: lineWidth = rectAttribute.lineWidth, strokeOpacity: strokeOpacity = rectAttribute.strokeOpacity, visible: visible = rectAttribute.visible, drawStrokeWhenZeroWH: drawStrokeWhenZeroWH = null !== (_a = rectAttribute.drawStrokeWhenZeroWH) && void 0 !== _a && _a} = rect.attribute;
        let {width: width, height: height} = rect.attribute;
        width = (null != width ? width : x1 - originX) || 0, height = (null != height ? height : y1 - originY) || 0;
        const z = null !== (_b = this.z) && void 0 !== _b ? _b : 0, fVisible = rectFillVisible(opacity, fillOpacity, width, height, fill), sVisible = rectStrokeVisible(opacity, strokeOpacity, width, height, drawStrokeWhenZeroWH), doFill = runFill(fill), doStroke = runStroke(stroke, lineWidth);
        if (!rect.valid || !visible) return;
        if (!doFill && !doStroke) return;
        if (!(fVisible || sVisible || fillCb || strokeCb)) return;
        const {light: light} = drawContext.stage || {}, face3d = rect.findFace();
        if (!1 !== fill) {
            context.setCommonStyle(rect, rect.attribute, x, y, rectAttribute);
            let fc = fill;
            "string" != typeof fc && (fc = "black"), this.fill(x, y, z, face3d, null, fc, context, light, null, null, fillCb);
        }
        !1 !== stroke && (context.setStrokeStyle(rect, rect.attribute, x, y, rectAttribute), 
        this.stroke(x, y, z, face3d, context));
    }
    draw(rect, renderService, drawContext) {
        const rectAttribute = getTheme(rect).rect;
        this._draw(rect, rectAttribute, !1, drawContext);
    }
}
//# sourceMappingURL=rect3d-render.js.map
